import React from "react";

import "./FormPage.css";

interface FormPageProps {
	variant?: "wide" | "narrow" | "ultra-narrow";
}

export const FormPage: React.FunctionComponent<
	React.PropsWithChildren<FormPageProps>
> = ({ children, variant = "wide" }) => (
	<div className={`form-page form-page--${variant}`}>{children}</div>
);
